import styled from 'styled-components';

const CoverImage = styled.div<CoverImageProps>`
  background-image: ${({ img }) => {
  if (img) return `url(${img})`;
  else return 'none';
}};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: ${({position}) => position};
  width: ${({width}) => width};
  height: ${({height}) => height};
`;

interface CoverImageProps {
  img?: string;
  position?: string,
  width?: string,
  height?: string,
}

CoverImage.defaultProps = {
  position: 'center',
  width: '100%',
  height: '100%'
}

export default CoverImage;
